<template>
  <div>

    <div id="app" :style="{ cursor: cursor }" v-if="app === false">
      
      <div class="head">
        <span class="progress" v-if="progress"></span>
        <p v-if="settings.app" v-html="settings.app.event_short + ' - ' + settings.app.event_title + '<br><span>' + settings.app.event_date + ', ' + settings.app.event_venue + '</span>'"></p>
        <p v-if="settings.app && settings.app.choose_language === '1'" class="languages">
          <span @click="changeLanguage('en')" :class="{ active: language == 'en'}">EN</span>
          <span @click="changeLanguage('de')" :class="{ active: language == 'de'}">DE</span>
        </p>
      </div>

      <div class="menu">
        <ul class="navigation" v-if="key">
          <li v-for="(rval, rkey) in routes.main" :key="rkey">
            <router-link :to="'/' + rval.route" :class="{ 'router-link-active': $route.path.match(new RegExp('^\/' + rval.route.slice(0, -1), 'i')) }">{{ _[rval.route] }}</router-link>
          </li>
        </ul>
      </div>

      <div class="body">
        <router-view />
      </div>

      <Modal />

    </div>

    <div v-else>
      <router-view />
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Modal from '@/components/Modal'
export default {
  components: {
    Modal,
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters(['cursor', 'key', 'language', 'settings', 'routes'])
  },
  methods: {
    ...mapActions(['changeLanguage']),
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/app.scss';
@import '@/assets/scss/layout.scss';
@import '@/assets/scss/progress.scss';
@import '@/assets/scss/modal.scss';
@import '@/assets/scss/navigation.scss';
@import '@/assets/scss/languages.scss';
#app > .menu > .navigation {
  > li {
    color: $primary-color;
    &.button {
      opacity: 1;
    }
    > a {
      opacity: 1;
      color: inherit;
      &.router-link-active {
        display: inline-block;
        height: 1px;
        box-shadow: 0 18px 0 0 lighten($primary-color, 30%);
      }
    }
  }
}
</style>